// tslint:disable-next-line:max-line-length
export const EmailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const GenericEmailRegex =
  /(admin|info|enquiries|reception|surgery|manager|pm|nurse|practicemanager|staff)@/i;
export const PasswordReg = /^(?=.*[A-Z])(?=.*\W).{8,}$/;
export const ISODateRegEx =
  /\b[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}(\.[0-9]{2,3})?Z\b/;
export const ApplicationSearchRegEx = /^.{4,}$/;
